import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { RollbackToVersionDialogData } from './rollback-to-version-dialog.data';

@Component({
    selector : 'rollback-to-version-dialog',
    template: require('./rollback-to-version-dialog.component.html'),
    styles: [require('./rollback-to-version-dialog.component.scss')]
})
export class RollbackToVersionDialogComponent {
    objectKeys = Object.keys;

    constructor(@Inject(MAT_DIALOG_DATA) public data: RollbackToVersionDialogData) {
        data.selectedAction = Object.keys(data.actions)[0]
        data.autoBackupSelected = data.autoBackUpItems[0].Key;
        data.autoRestoreSelected = data.autoRestoreItems[0].Key;
    }

    changeListByAction(selectedAction:any){
        this.data.byactions = (selectedAction=='ByPackage')? this.data.packages: this.data.labels
    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/rollback-to-version-dialog/rollback-to-version-dialog.component.ts